import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { SidebarTaskGroupUi } from '../../model/sidebar.model';
// import { PayerPortalGroupTemplateComponent } from './components/group-card-templates/payer-portal-group-template/payer-portal-group-template.component';
import { MailPackageGroupTemplateComponent } from './components/group-card-templates/mail-package-group-template/mail-package-group-template.component';
import { CreatePackageGroupTemplateComponent } from './components/group-card-templates/create-package-group-template/create-package-group-template.component';
import { CallPayerGroupTemplateComponent } from './components/group-card-templates/call-payer-group-template/call-payer-group-template.component';
import { ReviewGroupTemplateComponent } from './components/group-card-templates/review-group-template/review-group-template.component';
import { SidebarTaskComponent } from '../sidebar-task/sidebar-task.component';
import { TaskTypes } from 'src/app/shared/models/tasks.model';
import { AppPanelModule } from 'src/app/shared/components/panel/panel.module';
import { TaskItemStatus } from '@r1-development/resolution-mechanicalturk-api-client';
import { MatIconModule } from '@angular/material/icon';
import { ManualPortalGroupTemplateComponent } from './components/group-card-templates/manual-portal-group-template/manual-portal-group-template.component';

@Component({
  selector: 'ri-resolution-ui-sidebar-group-tasks',
  templateUrl: './sidebar-group-tasks.component.html',
  imports: [
    SidebarTaskComponent,
    AppPanelModule,
    MatIconModule,
    // PayerPortalGroupTemplateComponent,
    MailPackageGroupTemplateComponent,
    CreatePackageGroupTemplateComponent,
    CallPayerGroupTemplateComponent,
    ReviewGroupTemplateComponent,
    ManualPortalGroupTemplateComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SidebarGroupTasksComponent {
  // Input variables
  readonly groups = input<SidebarTaskGroupUi[]>();
  readonly showFetchButton = input<boolean>(false);
  readonly showLoader = input<boolean>(false);

  // Other
  readonly taskTypes = TaskTypes;
  readonly taskItemStatus = TaskItemStatus;
}
